// import 'react-app-polyfill/ie11';
import wrapWithProvider from './gatsby/wrap-with-provider'
import wrapWithLayout from './gatsby/wrap-with-layout'

// import 'prismjs/themes/prism-tomorrow.css'/
// import "prismjs/plugins/command-line/prism-command-line.css"

//mobx
export const wrapRootElement = wrapWithProvider
export const wrapPageElement = wrapWithLayout